"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function assertNever(message) {
    throw new Error(message != null
        ? message
        : 'This code should not be reachable and thus this is a programming error.');
}
exports.default = assertNever;
//# sourceMappingURL=assertNever.js.map